import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollToPlugin);

const scrollIntoView = (hash) => {
  const element = document.getElementById(hash);

  if (element) {
    gsap.to(window, { scrollTo: element });
  }
};

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    const hash = window.location.hash.substring(1);

    if (hash) scrollIntoView(hash);
  },
  {
    once: true,
  }
);
